import { render } from "./BCol.vue?vue&type=template&id=649e4f6c"
import script from "./BCol.vue?vue&type=script&lang=js"
export * from "./BCol.vue?vue&type=script&lang=js"

import exportComponent from "/Users/brianng/Documents/GitHub/SupaFoundationWeb2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__